import { Formik } from "formik";
import { Grid, List, ListItem, ListItemText, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { readLocalStorage } from "../../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../../types";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { SectionGeneralData } from "./SectionGeneralData";
import { SectionMainAddress } from "./SectionMainAddress";
import { SectionContacts } from "./SectionContacts";
import { SectionCommercialInformation } from "./SectionCommercialInformation";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";

type Values = {
    id: number,
    rut: string,
    name_rz: string,
    fantasy_name: string,
    web: string,
    giro: string,
    email: string,
    phone: string,
    fax: string,
    type: string,

    idbussines_area: number,
    idsalesman: number,
    idwaytopay: number,
    idaddress: number,
    idsegment: number,

    idcompany: number,
    status: string,
}

const sections = [
    'Datos generales',
    'Direcciones',
    'Información comercial',
    'Contactos',
];

type ContactFormat = {
    id: number | null
    n: number
    rut: string
    name: string
    charge: string
    phone: string
    email: string
}

type clientAddressFormat = {
    idcountry: number,
    iddepartment: number,
    idprovince: number,
    iddistrict: number,
    address: string,
}

export const SupplierModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, supplierSelected, listSuppliers, clearState } = props;

    const { createSupplier, editSupplier } = useSupplierStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const [loading, setLoading] = useState(false);
    const [currentSection, setCurrentSection] = useState<any>(0);
    const [contacts, setContacts] = useState<ContactFormat[]>([]);
    const [clientAddresses, setClientAddresses] = useState<clientAddressFormat[]>([]);

    const isSxSmMd = useMediaQuery('(min-width: 900px) and (max-width: 1536px)');

    const [data, setData] = useState<Values>({
        id: supplierSelected ? supplierSelected.id : '',
        rut: supplierSelected ? supplierSelected.rut : '',
        name_rz: supplierSelected ? supplierSelected.name_rz : '',
        fantasy_name: supplierSelected ? supplierSelected.fantasy_name : '',
        web: supplierSelected ? supplierSelected.web : '',
        giro: supplierSelected ? supplierSelected.giro : '',
        email: supplierSelected ? supplierSelected.email : '',
        phone: supplierSelected ? supplierSelected.phone : '',
        fax: supplierSelected ? supplierSelected.fax : '',
        type: supplierSelected ? supplierSelected.type : '',

        idbussines_area: supplierSelected ? supplierSelected.idbussines_area : '',
        idwaytopay: supplierSelected ? supplierSelected.idwaytopay : '',
        idaddress: supplierSelected ? supplierSelected.idaddress : '',
        idsalesman: supplierSelected?.idsalesman || '',
        idsegment: supplierSelected ? supplierSelected.idsegment : '',

        idcompany: supplierSelected ? supplierSelected.idcompany : '',
        status: supplierSelected ? supplierSelected.status : '',
    });

    useEffect(() => {
        if (supplierSelected?.contacts?.length > 0) {
            const Contacts = supplierSelected.contacts.map((contact, index) => {
                return {
                    id: contact.id,
                    n: index + 1,
                    rut: contact.rut,
                    name: contact.name,
                    charge: contact.position,
                    phone: contact.phone,
                    email: contact.email
                }
            })
            setContacts(Contacts || [])
        }

        if (supplierSelected?.clientAddresses?.length > 0) {
            const clientAddresses = supplierSelected.clientAddresses.map((address, index) => {
                return {
                    id: address.id,
                    idcountry: address.idcountry,
                    country: address.country,
                    iddepartment: address.iddepartment,
                    department: address.department,
                    idprovince: address.idprovince,
                    province: address.province,
                    iddistrict: address.iddistrict,
                    district: address.district,
                    address: address.address,
                    alias: address.alias,
                    is_billable: address.is_billable
                }
            })
            setClientAddresses(clientAddresses || [])
        }
    }, [supplierSelected])

    const handleSectionChange = (index) => {
        setCurrentSection(index);
    };
    const handleNextSection = () => {
        if (currentSection < sections.length - 1) setCurrentSection(currentSection + 1);
    };
    const handlePrevSection = () => {
        if (currentSection > 0) setCurrentSection(currentSection - 1);
    };
    const listItemStyle = {
        backgroundColor: '#1976d2',
        borderRadius: '10px',
        color: '#FFFFFF'
    };

    const onSubmit = async (dataProducts) => {
        setLoading(true);

        if (clientAddresses.length === 0) return CustomSnackbar('warning', 'Ingrese una dirección.')

        const payload = {
            ...dataProducts,
            idcompany: idcompany,
            legal_nature: '33',
            contacts: contacts,
            addresses: clientAddresses
        }

        if (supplierSelected) {
            const response: any = await editSupplier(supplierSelected.id, payload);
            if (response) {
                listSuppliers && listSuppliers();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        } else {
            const response: any = await createSupplier(payload);
            if (response) {
                listSuppliers && listSuppliers();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
            <ModalHeader
                text={supplierSelected ? 'Editar Proveedor/Cliente' : 'Nuevo Proveedor/Cliente'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody noscroll={isSxSmMd}>
                <Grid container display='flex' sx={{ height: '100vh' }}>
                    <Grid xs={12} pr={2} md={2}>
                        <List component="nav">
                            {sections.map((section, index) => (
                                <ListItem
                                    button
                                    key={index}
                                    onClick={() => handleSectionChange(index)}
                                    selected={index === currentSection}
                                    style={index === currentSection ? listItemStyle : {}}
                                >
                                    <ListItemText primary={section} primaryTypographyProps={{ style: { fontSize: '13px' } }} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid xs={12} md={10} sx={{ border: 'solid 1px #dad4d4', height: '85vh' }}>
                        <Grid sx={{ padding: '10px 5px 5px 20px' }}>
                            {sections[currentSection]}
                        </Grid>

                        <TabContext value={currentSection.toString()}>
                            <TabPanel value='0' sx={{ height: '95%' }}>
                                {
                                    <SectionGeneralData
                                        dataGeneral={data}
                                        setDataGeneral={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                    />
                                }
                            </TabPanel>
                            <TabPanel value='1' sx={{ height: '95%' }}>
                                {
                                    <SectionMainAddress
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        loadingsave={loading}
                                        clientAddresses={clientAddresses}
                                        setClientAddresses={setClientAddresses}
                                    />
                                }
                            </TabPanel>
                            <TabPanel value='2' sx={{ height: '95%' }}>
                                {
                                    <SectionCommercialInformation
                                        dataCommercial={data}
                                        setDataCommercial={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                    />
                                }
                            </TabPanel>
                            <TabPanel value='3' sx={{ height: '95%' }}>
                                {
                                    <SectionContacts
                                        dataContacts={data}
                                        setDataContacts={setData}
                                        currentSection={currentSection}
                                        handlePrevSection={handlePrevSection}
                                        handleNextSection={handleNextSection}
                                        sections={sections}
                                        onSubmit={onSubmit}
                                        loadingsave={loading}
                                        contacts={contacts}
                                        setContacts={setContacts}
                                    />
                                }
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}